import { render, staticRenderFns } from "./logwood-inventory.vue?vue&type=template&id=674e0d2e&scoped=true&"
import script from "./logwood-inventory.vue?vue&type=script&lang=ts&"
export * from "./logwood-inventory.vue?vue&type=script&lang=ts&"
import style0 from "./logwood-inventory.vue?vue&type=style&index=0&id=674e0d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674e0d2e",
  null
  
)

export default component.exports